import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { TbBreadcrumb } from "../components/TbBreadcrumb";
import { TbExplainer } from "../components/TbExplainer";
import { TextToBinaryTool } from "../components/TextToBinaryTool";

export function TextToBinaryPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <TbBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.tb_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.tb_intro()}
          </p>
        </header>

        <TextToBinaryTool />

        <TbExplainer
          howTo={m.tb_howto()}
          faqs={[
            { q: m.tb_faq1_q(), a: m.tb_faq1_a() },
            { q: m.tb_faq2_q(), a: m.tb_faq2_a() },
            { q: m.tb_faq3_q(), a: m.tb_faq3_a() },
            { q: m.tb_faq4_q(), a: m.tb_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
